export const DAY_REINITIALIZE = 26;
export const WITHOUT_TRANSMIT = 'Sin transmitir';
export const TRANSMIT = 'TRANSMITIDA';
export const FINALIZED = 'FINALIZADO';
export const REFUSED = 'RECHAZADA';
export const PARTIALLY_TRANSMITED = 'TRANSMITIDA PARCIALMENTE';
export const CONFIRMED_STATUS = ['3', '5', '6', '7', '9'];

export const ELECTRONIC_PAYROLL_NOVELTY_TRANSMISION_ERROR =
    'Hubo un error durante la transmisión de las novedades especiales. Por favor ingrese al portal de nomina electronica y transmitalas mediante este portal.';
